class AddEditServerControllerController {
    constructor(ServerControllersServiceApi, toastr, ScriptInjectionService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.serverController = null;
            this.IsRepoDisabled = true;
            this.data = {
                action: 'Create'
            };
            this.serverController = angular.copy(this.resolve.serverController);
            if (this.serverController === null || angular.isUndefined(this.serverController.Name)) {
                this.serverController = {
                    Id: -1,
                    Name: '',
                    Address: '',
                    APIServicePort: '',
                    AdminServicePort: '',
                    RepositoryEnabled: false,
                    IsDeleted: false
                };
                this.data.action = 'Create';
            }
            else {
                this.data.action = 'Update';
            }
            this.CheckdisableRepoConnection();
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.makeSafe = (str) => {
            // Remove Angular brackets incase someone injects them
            str = str.replace(/\{/g, '');
            return str.replace(/\}/g, '');
        };
        this.updateName = () => {
            if (this.serverController.Name !== undefined) {
                this.serverController.Name = this.makeSafe(this.serverController.Name);
            }
        };
        this.updateAddress = () => {
            if (this.serverController.Address !== undefined) {
                this.serverController.Address = this.makeSafe(this.serverController.Address);
            }
        };
        this.updateAPIServicePort = () => {
            if (this.serverController.APIServicePort !== undefined) {
                this.serverController.APIServicePort = this.makeSafe(this.serverController.APIServicePort);
            }
        };
        this.updateAdminServicePort = () => {
            if (!_.isEmpty(this.serverController.AdminServicePort)) {
                this.serverController.AdminServicePort = this.makeSafe(this.serverController.AdminServicePort);
                this.CheckdisableRepoConnection();
            }
            else {
                this.serverController.RepositoryEnabled = false;
                this.IsRepoDisabled = true;
            }
        };
        this.CheckdisableRepoConnection = () => {
            this.ServerControllersServiceApi.repoConnectionCheck(this.serverController.Id).then((response) => {
                // Are there other server controllers that have an admin service? -> Disable
                this.IsRepoDisabled = response.data || _.isEmpty(this.serverController.AdminServicePort);
                // Does this servercontroller already have a connection? -> Enable so we can turn it off
                if (this.serverController.RepositoryEnabled === true) {
                    this.IsRepoDisabled = false;
                }
            });
        };
        this.save = () => {
            if (this.ScriptInjectionService.isInjectedScript(this.serverController.Name)) {
                this.toastr.error('Name contains illegal characters');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(this.serverController.Address)) {
                this.toastr.error('Address contains illegal characters');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(this.serverController.APIServicePort)) {
                this.toastr.error('API Service Port contains illegal characters');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(this.serverController.AdminServicePort)) {
                this.toastr.error('Admin Service Port contains illegal characters');
                return;
            }
            if (this.serverController.APIServicePort === '' || angular.isUndefined(this.serverController.APIServicePort)) {
                this.toastr.error('API Port cannot be empty');
                return;
            }
            if (this.serverController.AdminServicePort === '0') {
                this.toastr.error('Admin Port cannot be 0');
                return;
            }
            if (this.serverController.APIServicePort === '0') {
                this.toastr.error('API Port cannot be 0');
                return;
            }
            this.ServerControllersServiceApi.save(this.serverController).then((response) => {
                if (!angular.isUndefined(response)) {
                    if (response.data.errors.length > 0) {
                        angular.forEach(response.data.errors, (validationError) => {
                            this.toastr.error(validationError);
                        });
                        return;
                    }
                    this.resolve.serverController = this.serverController;
                    this.close({ $value: this.data.action + 'd' });
                }
                else {
                    this.toastr.info('Error Saving Details please double check all mandatory fields are completed.');
                }
            });
        };
        this.ServerControllersServiceApi = ServerControllersServiceApi;
        this.toastr = toastr;
        this.ScriptInjectionService = ScriptInjectionService;
    }
}
angular.module('app').component('addEditServerControllerModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ServerControllers/add-edit-server-controller-modal.tpl.html',
    controllerAs: 'vm',
    controller: AddEditServerControllerController
});
